"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _sx, _sx2, _n;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Estimator = void 0;
/**
 * Simple and fast stats: mean, S2, stdev (estimated standard deviation).
 * Parsec uses it for clock synchronization which is often used in its
 * application protocols.
 *
 * It uses effective estimation algorithms that do not store the whole series
 * so could be same effective used with tiny arrays and large streams of samples.
 */
class Estimator {
    constructor() {
        _sx.set(this, void 0);
        _sx2.set(this, void 0);
        _n.set(this, void 0);
        __classPrivateFieldSet(this, _sx, 0);
        __classPrivateFieldSet(this, _sx2, 0);
        __classPrivateFieldSet(this, _n, 0);
    }
    /**
     * Current number of samples
     */
    get count() {
        return __classPrivateFieldGet(this, _n);
    }
    /**
     * current mean value
     */
    get mean() {
        return __classPrivateFieldGet(this, _sx) / __classPrivateFieldGet(this, _n);
    }
    /**
     * Current Sample Variance estimation, e.g. 𝛔²(n-1)
     */
    get s2() {
        const n = __classPrivateFieldGet(this, _n);
        const m = this.mean;
        return (__classPrivateFieldGet(this, _sx2) - n * m * m) / (n - 1);
    }
    /**
     * Estimated standard deviation, √𝛔² (square root of sample variance estimation)
     */
    get stdev() {
        return Math.sqrt(this.s2);
    }
    /**
     * Add next sample to series.
     *
     * @param x value to add.
     */
    addSample(x) {
        __classPrivateFieldSet(this, _sx, __classPrivateFieldGet(this, _sx) + x);
        __classPrivateFieldSet(this, _sx2, __classPrivateFieldGet(this, _sx2) + (x * x));
        __classPrivateFieldSet(this, _n, +__classPrivateFieldGet(this, _n) + 1);
    }
    /**
     * clear current series so it can restart calulation
     */
    clear() {
        __classPrivateFieldSet(this, _sx, __classPrivateFieldSet(this, _sx2, __classPrivateFieldSet(this, _n, 0)));
    }
    toString() {
        return `(${this.mean} ± ${this.stdev.toPrecision(3)})`;
    }
}
exports.Estimator = Estimator;
_sx = new WeakMap(), _sx2 = new WeakMap(), _n = new WeakMap();
//# sourceMappingURL=Estimator.js.map